<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Log Activity" subTitle="Forms" />

    <ListLogActivity />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListLogActivity from "@/components/Pages/Management/LogActivity/ListLogActivity.vue";

export default defineComponent({
  name: "ListLogActivityPage",
  components: {
    PageTitle,
    ListLogActivity,
  },
});
</script>
